import React, { useContext, useRef } from "react";
// import {submitButton} from '/public/submit-button.png';
import { useState } from "react";
import { API_URL } from "./../../../const.js";
import ChatHistory from "./ChatHistory.js";
import "./style.css";
import { Tooltip, Typography, message as antdMessage } from "antd";
import { VscSend } from "react-icons/vsc";
import { AiOutlineAudio, AiFillAudio } from "react-icons/ai";
import { GptContext } from "./ChatbotContainer.js";
import html2canvas from "html2canvas";

const { Text } = Typography;

// Toggle screenshot capture: Set to false to disable screenshots with chat messages
const INCLUDE_SCREENSHOT = false;

const MessageTypes = {
    Summary: 1,
    Question: 2,
    ExpandsOn: 3
}

const MessageBox = () => {
    const {
        setMessages,
        loading,
        setLoading,
        video,
        collection,
        module,
        pauseVideo,
        isCollectionOwner,
        messages
    } = useContext(GptContext);
    const textareaRef = useRef(null);

    const [activeButton, setActiveButton] = useState(null);
    // 1: Summary Button
    // 2: Question Button
    // 3: Extend On Button

    const [textareaValue, setTextareaValue] = useState("");
    // const [showalert, setShowAlert] = useState(false);

    const [iconColor, setIconColor] = useState("black");
    const [isListening, setIsListening] = useState(false);

    const [visibleExpandsOnHistory, setVisibleExpandsOnHistory] =
        useState(true);

    const handleTextareaChange = (event) => {
        setTextareaValue(event.target.value);

        if (event.target.value === "") {
            setIconColor("black");
        } else {
            setIconColor("rgba(30, 112, 105, 0.9)");
        }
    };

    const fetchSummary = (collectionId, videoId) => {
        setLoading(true);
        fetch(API_URL + `/api/v1/gpt/summary/${collectionId}/${videoId}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("access")
            }
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Network response was not ok");
                }
            })
            .then((response) => {
                if (response.data) {
                    sendMessage(
                        MessageTypes.Summary,
                        response.data.content,
                        "GPT",
                        response.data.id
                    );
                } else {
                    sendMessage(
                        MessageTypes.Summary,
                        "We are sorry! We have no summaries for this context.",
                        "GPT"
                    );
                }
                setLoading(false);
            });
    };

    const fetchQuestion = (prompt, collectionId, videoId) => {
        setLoading(true);

        fetch(
            API_URL +
            `/api/v1/gpt/generate-question/${collectionId}/${videoId}`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("access")
                },
                body: prompt
            }
        )
            .then((response) => response.json())
            .then((result) => {
                if (result.content) {
                    sendMessage(MessageTypes.Question, result.content, "GPT", result.id);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error submitting data:", error);
                setLoading(false);
            });
    };

    const captureVideoScreenshot = async () => {
        try {
            // Try to capture the video wrapper element
            const videoWrapper = document.getElementById('video-wrapper');
            if (videoWrapper) {
                const canvas = await html2canvas(videoWrapper, {
                    allowTaint: true,
                    useCORS: true,
                    logging: false,
                    backgroundColor: '#000000'
                });
                // Convert canvas to blob
                return new Promise((resolve) => {
                    canvas.toBlob((blob) => {
                        resolve(blob);
                    }, 'image/png');
                });
            }
        } catch (error) {
            console.error("Error capturing screenshot:", error);
        }
        return null;
    };

    const fetchExpandOn = async (prompt, collectionId, videoId) => {
        setLoading(true);
        
        let requestBody;
        let headers = {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.getItem("access")
        };
        
        if (INCLUDE_SCREENSHOT) {
            // Capture screenshot before sending
            const screenshotBlob = await captureVideoScreenshot();
            
            // Create FormData for multipart form submission
            const formData = new FormData();
            formData.append('prompt', prompt);
            if (screenshotBlob) {
                formData.append('screenshot', screenshotBlob, 'screenshot.png');
            }
            requestBody = formData;
            // Don't set Content-Type - browser will set it with boundary for FormData
        } else {
            // Send as JSON object (backend expects dict with 'prompt' key)
            requestBody = JSON.stringify({prompt: prompt});
            headers["Content-Type"] = "application/json";
        }
        
        fetch(API_URL + `/api/v1/gpt/get-expandOn/${collectionId}/${videoId}`, {
            method: "POST",
            headers: headers,
            body: requestBody
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.content) {
                    sendMessage(MessageTypes.ExpandsOn, result.content, "GPT", result.id, result.imageUrl);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error submitting data:", error);
                setLoading(false);
            });
    };

    const sendMessage = (type, messageText, user, elementId = undefined, imageUrl = undefined) => {
        let mcq = false;

        if (type === MessageTypes.Question) {
            mcq = true;
        }

        const newMessage = {
            user: user,
            content: messageText,
            mcq: mcq,
            element: type,
            elementId: elementId,
            imageUrl: imageUrl
        };
        setMessages((prev) => [...prev, newMessage]);

        setActiveButton(null);
        setTextareaValue("");
    };

    const handleMessageSubmit = (type = undefined, query = undefined) => {
        // if (!type && activeButton === null) {
        //     setShowAlert(true);
        //     return;
        // }

        if (!type) {
            type = activeButton || MessageTypes.ExpandsOn;
        }

        let searchQuery = textareaValue;
        let message = textareaValue;
        if (query) {
            searchQuery = query.text;
            message = query.message;
        }
        sendMessage(type, message, "USER", 0);

        switch (type) {
            case MessageTypes.Summary:
                setTimeout(() => {
                    setActiveButton(type);
                    fetchSummary(collection.id, video.id);
                }, 100);

                break;

            case MessageTypes.Question:
                setTimeout(() => {
                    setActiveButton(type);
                    fetchQuestion(searchQuery, collection.id, video.id);
                }, 100);

                break;

            case MessageTypes.ExpandsOn:
                if (query && query.history) {
                    sendMessage(
                        MessageTypes.ExpandsOn,
                        query.history.answer,
                        "GPT",
                        query.history.id
                    );
                } else {
                    setTimeout(() => {
                        fetchExpandOn(searchQuery, collection.id, video.id);
                    }, 100);
                }
                break;

            default:
                break;
        }
    };

    const focusOnTextBox = () => {
        setTimeout(() => {
            textareaRef.current.focus();
            textareaRef.current.selectionStart =
                textareaRef.current.value.length;
            textareaRef.current.selectionEnd = textareaRef.current.value.length;
        }, 100);
    };

    const onButtonClick = (type) => {
        pauseVideo();
        setActiveButton(type);
        setIconColor("rgba(30, 112, 105, 0.9)");
        // setShowAlert(false);
        // setVisibleExpandsOnHistory(
        //     messages.filter((m) => m.element !== 0).length === 0 && type === 3
        // );
        setVisibleExpandsOnHistory(false);

        const query =
            type === MessageTypes.Summary
                ? `Provide a summary of "${video.title}"`
                : type === MessageTypes.Question
                    ? `Generate a MCQ on "${collection.name} - ${module.name} - ${video.title}"`
                    : ``;

        if ((isCollectionOwner && type !== MessageTypes.Question) || type === MessageTypes.ExpandsOn) {
            setTextareaValue(query);
            focusOnTextBox();
            return;
        }

        const sendingMessage =
            type === MessageTypes.Summary
                ? `Generating a summary of "${video.title}"`
                : `Generating a MCQ on "${collection.name} - ${module.name} - ${video.title}"`;
        handleMessageSubmit(type, {
            text: query,
            message: sendingMessage
        });
    };

    const onExpandOnHistoryItemClick = (history) => {
        setTextareaValue(history.question);
        setVisibleExpandsOnHistory(false);
        handleMessageSubmit(MessageTypes.ExpandsOn, {
            text: history.question,
            message: history.question,
            history: history
        });
    };

    const onExpandOnHistoryToggle = (expanded) => {
        setVisibleExpandsOnHistory(expanded);
    };

    const onEnterPress = (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault();
            handleMessageSubmit();
        }
    }

    const startVoiceInput = () => {
        if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
            antdMessage.error('Voice input not supported in your browser');
            return;
        }

        const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new Recognition();
        recognition.lang = 'en-US';
        recognition.continuous = false;
        recognition.interimResults = true;

        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            setTextareaValue(transcript);
            setIconColor("rgba(30, 112, 105, 0.9)");
        };

        recognition.onend = () => {
            setIsListening(false);
        };

        recognition.onerror = (event) => {
            setIsListening(false);
            if (event.error === 'not-allowed') {
                antdMessage.error('Microphone permission denied. Please enable microphone access.');
            } else {
                antdMessage.error('Voice recognition error. Please try again.');
            }
        };

        try {
            recognition.start();
            setIsListening(true);
        } catch (error) {
            antdMessage.error('Failed to start voice recognition');
        }
    };

    return (
        <div id="wrapper" className="cugpt-wrapper">
            <ChatHistory
                id="chat-history"
                visibleExpandsOnHistory={visibleExpandsOnHistory}
                onExpandOnHistoryItemClick={onExpandOnHistoryItemClick}
                onExpandOnHistoryToggle={onExpandOnHistoryToggle}
            />

            <div id="box">
                {/* {showalert && (
                    <div id="alert">
                        Select an option before you submit a message!
                    </div>
                )} */}

                <div id="buttons">
                    <div>
                        <Tooltip
                            title={
                                "Get a summary of the important takeaways from this lesson."
                            }>
                            <button
                                id={
                                    activeButton === MessageTypes.Summary
                                        ? "summary-clicked"
                                        : "summarize-button"
                                }
                                disabled={loading}
                                onClick={() => onButtonClick(MessageTypes.Summary)}>
                                Summarize Video
                            </button>
                        </Tooltip>
                    </div>
                    <div>
                        <Tooltip
                            title={"Generates a multiple choice question."}>
                            <button
                                id={
                                    activeButton === MessageTypes.Question
                                        ? "question-clicked"
                                        : "question-button"
                                }
                                disabled={loading}
                                onClick={() => onButtonClick(MessageTypes.Question)}>
                                Generate MCQ
                            </button>
                        </Tooltip>
                    </div>
                    {/* <div>
                        <Tooltip
                            title={
                                "Ask for clarification on the content, a real-world application of a concept, etc."
                            }>
                            <button
                                id={
                                    activeButton === 3
                                        ? "expandOn-clicked"
                                        : "expand-button"
                                }
                                disabled={loading}
                                onClick={() => onButtonClick(3)}>
                                Expand On...
                            </button>
                        </Tooltip>
                    </div> */}
                </div>

                <div
                    id="message-box"
                >
                    <textarea
                        ref={textareaRef}
                        id="message"
                        value={textareaValue}
                        placeholder={"Ask your question in a thoughtful, clear and concise manner with reference to context!"}
                        onKeyDown={onEnterPress}
                        onChange={handleTextareaChange}></textarea>

                    <button
                        type="button"
                        onClick={startVoiceInput}
                        disabled={isListening || loading}
                        id="voice-input-button"
                        className={isListening ? "listening" : ""}
                        title="Voice input">
                        {isListening ? (
                            <AiFillAudio size={24} color="rgba(30, 112, 105, 0.9)" />
                        ) : (
                            <AiOutlineAudio size={24} color="black" />
                        )}
                    </button>

                    <button
                        type="submit"
                        disabled={!textareaValue}
                        onClick={() => handleMessageSubmit()}
                        id="submit-button">
                        <VscSend
                            size={30}
                            color={iconColor}
                            className="submit-button"
                        />
                    </button>
                </div>
                <Text type="secondary" style={{ padding: "4px 0px", fontSize: "11px" }}>Press Enter or click the Send button to submit your message to the cuGPT.</Text>
            </div>
        </div>
    );
};
export default MessageBox;
